import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-950 via-dark-900 to-dark-800 text-gray-300 py-16">
      <Helmet>
        <title>Privacy Policy - LeadGen AI</title>
        <meta name="description" content="Read LeadGen AI privacy policy. Learn how we collect, use and protect your data." />
        <link rel="canonical" href="https://leadgenai.in/privacy" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Privacy Policy</h1>
          <p className="text-gray-400">Last updated: June 2025</p>
        </div>

        <div className="space-y-10 bg-zinc-900/50 p-8 md:p-12 rounded-2xl border border-white/10/60 shadow-xl backdrop-blur-sm prose prose-invert prose-slate max-w-none">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Information We Collect</h2>
            <p>We collect information that you provide directly to us, including your name, email address, password, and search history history. When you interact with LeadGen AI, we securely store this information to provide our core services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. How We Use Your Information</h2>
            <p>The information we collect is used in the following ways:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1 ml-4 block">
              <li>To provide, maintain, and improve our services</li>
              <li>To process your transactions and manage your subscription</li>
              <li>To send you technical notices, updates, and support messages</li>
              <li>To understand and analyze how you use our application</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Data Storage</h2>
            <p>Your data is stored securely using industry-standard databases (e.g., SQLite/cloud databases). We implement rigorous security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Third Party Services</h2>
            <p>We utilize the Google Places API and other web scraping technologies to retrieve business information. We do not share your personal account information with these third-party services. The external data we collect on your behalf adheres to the terms of service of the respective providers.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Cookies & Local Storage</h2>
            <p>We use JWT (JSON Web Tokens) stored in your browser's local storage to maintain your active session. These are strictly necessary for the application to function. We may also use essential cookies to enhance performance.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Data Retention</h2>
            <p>We retain your search history and lead data based on your subscription plan:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1 ml-4 block">
              <li><strong>Basic Plan:</strong> 7 Days</li>
              <li><strong>Standard Plan:</strong> 30 Days</li>
              <li><strong>Premium Plan:</strong> Unlimited</li>
            </ul>
            <p className="mt-2">If you delete your account, all associated data is permanently erased from our active database.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal data at any time. You can export your leads using our built-in CSV/Excel tools, and you may delete your account from the dashboard settings.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Security</h2>
            <p>We take security seriously. All passwords are hashed using bcrypt before being saved to the database. API endpoints are protected via JWT encryption to ensure your data remains completely confidential.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Changes to Policy</h2>
            <p>We may update this privacy policy from time to time. If we make significant changes, we will notify you through the application or via email.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <p className="mt-2 text-blue-400">
              <Link to="/contact" className="hover:underline">Contact Support Team</Link>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
